// FECOA-1451 — exit an active assessment back to the dashboard.
// The app header (HomeNavMenu) and the survey-taking flow are separate component
// trees, so the header's Dashboard/logo clicks request an exit via a window event;
// SurveyTaking owns the confirm dialog and the save-and-leave behavior.
export const SURVEY_EXIT_REQUEST_EVENT = 'flexcoa:survey-exit-request';

export const requestSurveyExit = () => {
  window.dispatchEvent(new CustomEvent(SURVEY_EXIT_REQUEST_EVENT));
};
